import { Middleware } from 'redux';

import * as authConstants from 'redux/constants/auth.constants';
import * as blocksConstants from 'redux/constants/blocks.constants';
import * as categoryPricesConstants from 'redux/constants/categoryPrices.constants';
import * as cementeriesConstants from 'redux/constants/cementeries.constants';
import * as divorcesConstants from 'redux/constants/divorces.constants';
import * as deathsConstants from 'redux/constants/deaths.constants';
import * as documentsConstants from 'redux/constants/documents.constants';
import * as documentsTypesConstants from 'redux/constants/documentsTypes.constants';
import * as gravesConstants from 'redux/constants/graves.constants';
import * as jewishnessConstants from 'redux/constants/jewishness.constants';
import * as marriagesConstants from 'redux/constants/marriages.constants';
import * as matzevaConstants from 'redux/constants/matzeva.constants';
import * as permissionsConstants from 'redux/constants/permissions.constants';
import * as personsConstants from 'redux/constants/persons.constants';
import * as proceduresConstants from 'redux/constants/procedures.constants';
import * as proceduresEmailsConstants from 'redux/constants/proceduresEmails.constants';
import * as reservationsConstants from 'redux/constants/reservations.constants';
import * as rolesConstants from 'redux/constants/roles.constants';
import * as usersConstants from 'redux/constants/users.constants';

import { showSuccessNotification, showErrorNotification } from 'helpers/notifications';

const notificationMiddleware: Middleware = () => (next) => (action) => {
  const { data, error, type } = action;
  switch (type) {
    case authConstants.AUTH_ON_LOGIN_SUCCEEDED:
    case authConstants.AUTH_ON_LOGIN_PUBLIC_SUCCEEDED:
    case authConstants.AUTH_ON_REGISTER_PUBLIC_SUCCEEDED:
    case blocksConstants.BLOCKS_ON_DELETE_SUCCEEDED:
    case blocksConstants.BLOCKS_ON_SAVE_SUCCEEDED:
    case categoryPricesConstants.CATEGORY_PRICES_ON_DELETE_SUCCEEDED:
    case categoryPricesConstants.CATEGORY_PRICES_ON_SAVE_SUCCEEDED:
    case cementeriesConstants.CEMENTERIES_ON_DELETE_SUCCEEDED:
    case cementeriesConstants.CEMENTERIES_ON_SAVE_SUCCEEDED:
    case divorcesConstants.DIVORCES_ON_DELETE_SUCCEEDED:
    case divorcesConstants.DIVORCES_ON_DELETE_FILE_SUCCEEDED:
    case divorcesConstants.DIVORCES_ON_SAVE_SUCCEEDED:
    case deathsConstants.DEATHS_ON_DELETE_SUCCEEDED:
    case deathsConstants.DEATHS_ON_SAVE_SUCCEEDED:
    case documentsConstants.DOCUMENTS_ON_DELETE_SUCCEEDED:
    case documentsConstants.DOCUMENTS_ON_SAVE_SUCCEEDED:
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_DELETE_SUCCEEDED:
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_SAVE_SUCCEEDED:
    case gravesConstants.GRAVES_ON_DELETE_SUCCEEDED:
    case gravesConstants.GRAVES_ON_SAVE_SUCCEEDED:
    case jewishnessConstants.JEWISHNESS_ON_DELETE_SUCCEEDED:
    case jewishnessConstants.JEWISHNESS_ON_DELETE_FILE_SUCCEEDED:
    case jewishnessConstants.JEWISHNESS_ON_SAVE_SUCCEEDED:
    case marriagesConstants.MARRIAGES_ON_DELETE_SUCCEEDED:
    case marriagesConstants.MARRIAGES_ON_DELETE_FILE_SUCCEEDED:
    case marriagesConstants.MARRIAGES_ON_SAVE_SUCCEEDED:
    case matzevaConstants.MATZEVA_ON_DELETE_SUCCEEDED:
    case matzevaConstants.MATZEVA_ON_SAVE_SUCCEEDED:
    case permissionsConstants.PERMISSIONS_ON_DELETE_SUCCEEDED:
    case permissionsConstants.PERMISSIONS_ON_SAVE_SUCCEEDED:
    case personsConstants.PERSONS_ON_DELETE_SUCCEEDED:
    case personsConstants.PERSONS_ON_SAVE_SUCCEEDED:
    case proceduresConstants.PROCEDURES_ON_DELETE_SUCCEEDED:
    case proceduresConstants.PROCEDURES_ON_DELETE_FILE_SUCCEEDED:
    case proceduresConstants.PROCEDURES_ON_SAVE_SUCCEEDED:
    case proceduresEmailsConstants.PROCEDURES_EMAILS_ON_RESEND_SUCCEEDED:
    case proceduresEmailsConstants.PROCEDURES_EMAILS_ON_SEND_EMAILS_SUCCEEDED:
    case rolesConstants.ROLES_ON_DELETE_SUCCEEDED:
    case rolesConstants.ROLES_ON_SAVE_SUCCEEDED:
    case reservationsConstants.RESERVATIONS_ON_DELETE_SUCCEEDED:
    case reservationsConstants.RESERVATIONS_ON_SAVE_SUCCEEDED:
    case usersConstants.USERS_ON_DELETE_SUCCEEDED:
    case usersConstants.USERS_ON_SAVE_SUCCEEDED:
    case usersConstants.USERS_ON_VERIFY_SUCCEEDED:
      showSuccessNotification(data.message);
      break;
    case authConstants.AUTH_ON_LOGIN_FAILED:
    case authConstants.AUTH_ON_LOGIN_PUBLIC_FAILED:
    case authConstants.AUTH_ON_LOGOUT_FAILED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_FAILED:
    case authConstants.AUTH_ON_REGISTER_PUBLIC_FAILED:
    case blocksConstants.BLOCKS_ON_DELETE_FAILED:
    case blocksConstants.BLOCKS_ON_GET_ALL_FAILED:
    case blocksConstants.BLOCKS_ON_GET_ONE_FAILED:
    case categoryPricesConstants.CATEGORY_PRICES_ON_DELETE_FAILED:
    case categoryPricesConstants.CATEGORY_PRICES_ON_GET_ALL_FAILED:
    case categoryPricesConstants.CATEGORY_PRICES_ON_GET_ONE_FAILED:
    case cementeriesConstants.CEMENTERIES_ON_DELETE_FAILED:
    case cementeriesConstants.CEMENTERIES_ON_GET_ALL_FAILED:
    case cementeriesConstants.CEMENTERIES_ON_GET_ONE_FAILED:
    case divorcesConstants.DIVORCES_ON_DELETE_FAILED:
    case divorcesConstants.DIVORCES_ON_DELETE_FILE_FAILED:
    case divorcesConstants.DIVORCES_ON_GET_ALL_FAILED:
    case divorcesConstants.DIVORCES_ON_GET_ONE_FAILED:
    case deathsConstants.DEATHS_ON_DELETE_FAILED:
    case deathsConstants.DEATHS_ON_GET_ALL_FAILED:
    case deathsConstants.DEATHS_ON_GET_ONE_FAILED:
    case documentsConstants.DOCUMENTS_ON_DELETE_FAILED:
    case documentsConstants.DOCUMENTS_ON_GET_ALL_FAILED:
    case documentsConstants.DOCUMENTS_ON_GET_ONE_FAILED:
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_DELETE_FAILED:
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_GET_ALL_FAILED:
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_GET_ONE_FAILED:
    case gravesConstants.GRAVES_ON_DELETE_FAILED:
    case gravesConstants.GRAVES_ON_GET_ALL_FAILED:
    case gravesConstants.GRAVES_ON_GET_ONE_FAILED:
    case jewishnessConstants.JEWISHNESS_ON_DELETE_FAILED:
    case jewishnessConstants.JEWISHNESS_ON_DELETE_FILE_FAILED:
    case jewishnessConstants.JEWISHNESS_ON_GET_ALL_FAILED:
    case jewishnessConstants.JEWISHNESS_ON_GET_ONE_FAILED:
    case marriagesConstants.MARRIAGES_ON_DELETE_FAILED:
    case marriagesConstants.MARRIAGES_ON_DELETE_FILE_FAILED:
    case marriagesConstants.MARRIAGES_ON_GET_ALL_FAILED:
    case marriagesConstants.MARRIAGES_ON_GET_ONE_FAILED:
    case matzevaConstants.MATZEVA_ON_DELETE_FAILED:
    case matzevaConstants.MATZEVA_ON_GET_ALL_FAILED:
    case matzevaConstants.MATZEVA_ON_GET_ONE_FAILED:
    case permissionsConstants.PERMISSIONS_ON_DELETE_FAILED:
    case permissionsConstants.PERMISSIONS_ON_GET_ALL_FAILED:
    case permissionsConstants.PERMISSIONS_ON_GET_ONE_FAILED:
    case personsConstants.PERSONS_ON_DELETE_FAILED:
    case personsConstants.PERSONS_ON_GET_ALL_FAILED:
    case personsConstants.PERSONS_ON_GET_ONE_FAILED:
    case proceduresConstants.PROCEDURES_ON_DELETE_FAILED:
    case proceduresConstants.PROCEDURES_ON_DELETE_FILE_FAILED:
    case proceduresConstants.PROCEDURES_ON_GET_ALL_FAILED:
    case proceduresConstants.PROCEDURES_ON_GET_ONE_FAILED:
    case proceduresEmailsConstants.PROCEDURES_EMAILS_ON_GET_ALL_FAILED:
    case proceduresEmailsConstants.PROCEDURES_EMAILS_ON_RESEND_FAILED:
    case proceduresEmailsConstants.PROCEDURES_EMAILS_ON_SEND_EMAILS_FAILED:
    case rolesConstants.ROLES_ON_DELETE_FAILED:
    case rolesConstants.ROLES_ON_GET_ALL_FAILED:
    case rolesConstants.ROLES_ON_GET_ONE_FAILED:
    case reservationsConstants.RESERVATIONS_ON_DELETE_FAILED:
    case reservationsConstants.RESERVATIONS_ON_GET_ALL_FAILED:
    case reservationsConstants.RESERVATIONS_ON_GET_ONE_FAILED:
    case usersConstants.USERS_ON_DELETE_FAILED:
    case usersConstants.USERS_ON_GET_ALL_FAILED:
    case usersConstants.USERS_ON_GET_ONE_FAILED:
    case usersConstants.USERS_ON_VERIFY_FAILED:
      showErrorNotification(error.response?.data?.message || error.message);
      break;
    case blocksConstants.BLOCKS_ON_SAVE_FAILED:
    case categoryPricesConstants.CATEGORY_PRICES_ON_SAVE_FAILED:
    case cementeriesConstants.CEMENTERIES_ON_SAVE_FAILED:
    case divorcesConstants.DIVORCES_ON_SAVE_FAILED:
    case deathsConstants.DEATHS_ON_SAVE_FAILED:
    case documentsConstants.DOCUMENTS_ON_SAVE_FAILED:
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_SAVE_FAILED:
    case gravesConstants.GRAVES_ON_SAVE_FAILED:
    case jewishnessConstants.JEWISHNESS_ON_SAVE_FAILED:
    case marriagesConstants.MARRIAGES_ON_SAVE_FAILED:
    case matzevaConstants.MATZEVA_ON_SAVE_FAILED:
    case permissionsConstants.PERMISSIONS_ON_SAVE_FAILED:
    case personsConstants.PERSONS_ON_SAVE_FAILED:
    case proceduresConstants.PROCEDURES_ON_SAVE_FAILED:
    case rolesConstants.ROLES_ON_SAVE_FAILED:
    case reservationsConstants.RESERVATIONS_ON_SAVE_FAILED:
    case usersConstants.USERS_ON_SAVE_FAILED:
      if (error.response?.data?.errors?.length)
        error.response.data.errors.forEach((message: string) => showErrorNotification(message));
      else showErrorNotification(error.response?.data?.message || error.message);
      break;
    default:
      if (error?.response?.status === 401)
        showErrorNotification(error.response?.data?.message || error.message);
      break;
  }
  return next(action);
};

export default notificationMiddleware;
